(function () {
  function clearScrollLock() {
    document.body.classList.remove('home-about-modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }

  function initHomeAboutModal(section) {
    if (section.dataset.homeAboutModalBound === 'true') return;
    section.dataset.homeAboutModalBound = 'true';

    var root = section.querySelector('[data-home-about-modal-root]');
    var backdrop = section.querySelector('[data-home-about-modal-backdrop]');
    var modal = section.querySelector('[data-home-about-modal]');
    var closeBtn = section.querySelector('[data-home-about-modal-close]');
    var triggers = section.querySelectorAll('[data-home-about-modal-trigger]');

    if (!root || !backdrop || !modal || !triggers.length) return;

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var isOpen = false;
    var activeTrigger = null;

    function lockScroll() {
      var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarW > 0) {
        document.body.style.paddingRight = scrollbarW + 'px';
      }
      document.body.classList.add('home-about-modal-open');
    }

    function openModal(trigger) {
      if (isOpen) return;
      isOpen = true;
      activeTrigger = trigger;

      root.removeAttribute('hidden');
      lockScroll();

      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      window.setTimeout(function () {
        if (closeBtn) {
          closeBtn.focus();
        } else {
          modal.focus();
        }
      }, 0);
    }

    function closeModal() {
      if (!isOpen) return;
      isOpen = false;
      clearScrollLock();
      root.classList.remove('is-open');

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
        activeTrigger = null;
      }

      window.setTimeout(function () {
        if (!isOpen) {
          root.setAttribute('hidden', '');
        }
      }, 520);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(trigger);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeModal();
    });
  }

  function preventHomeGridImageDrag(section) {
    if (section.dataset.homeGridDragBound === 'true') return;
    section.dataset.homeGridDragBound = 'true';

    section.addEventListener('dragstart', function (event) {
      if (event.target.closest('.home-grid__image, .home-grid__placeholder, .home-grid__video')) {
        event.preventDefault();
      }
    });
  }

  function boot() {
    clearScrollLock();
    document.querySelectorAll('.home-grid').forEach(preventHomeGridImageDrag);
    document.querySelectorAll('[data-home-about-modal-section]').forEach(initHomeAboutModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', clearScrollLock);

  document.addEventListener('shopify:section:load', function (event) {
    var homeGrid = event.target.matches('.home-grid')
      ? event.target
      : event.target.querySelector('.home-grid');
    if (homeGrid) preventHomeGridImageDrag(homeGrid);

    var section = event.target.matches('[data-home-about-modal-section]')
      ? event.target
      : event.target.querySelector('[data-home-about-modal-section]');
    if (section) initHomeAboutModal(section);
  });
})();
